/* eslint-disable vue/no-parsing-error */
<template>

    <div class="search-results">
        <site-header :userAuthenticated="true"></site-header>
        <breadcrumb>
            <router-link to="/">Home</router-link>
            <span> > </span>
            <router-link :to="'/search/' + companySearchId">Company Search</router-link>
            <span> > </span>
            <router-link :to="'/results/' + companySearchId" class="active">Results</router-link>
            <print-icon></print-icon>
        </breadcrumb>

        <div class="container group">
            <side-menu>
                <nav>
                    <ul class="no-style-list">
                        <li>
                            <router-link :to="'/search/' + companySearchId">
                                <input-button :btn-class="'btn-grey'" class="btn-edit-search">Edit search criteria <font-awesome-icon icon="edit" /></input-button>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/search">
                                <input-button :btn-class="'btn-grey'" class="btn-start-new-search">Start new search<font-awesome-icon icon="search" /></input-button>
                            </router-link>
                        </li>
                        <li>
                            <upload-companies @arrayChanged="updateUploadedFiles" :uploadedFiles="search.files"></upload-companies>
                        </li>
                        <li>
                            <div @click="removeSelected">
                                <input-button :btn-class="'btn-red'" class="btn-remove-selected">Remove selected <font-awesome-icon icon="times-circle" /></input-button>
                            </div>
                        </li>
                        <li>
                            <div @click="excludeBlockedChange()">
                                <input-button v-if="search.excludeBlocked === true" :btn-class="'btn-grey'" class="btn-remove-selected">Show Blocked <font-awesome-icon icon="ban" /></input-button>
                                <input-button v-if="search.excludeBlocked === false" :btn-class="'btn-grey'" class="btn-remove-selected">Hide Blocked <font-awesome-icon icon="ban" /></input-button>
                            </div>
                        </li>
                    </ul>

                    <section class="group criteria-selected">

                        <criteria-selected :search="search"></criteria-selected>
                        <button class="fake-anchor" @click="excludeSubsidiariesAndIntermediates">Exclude subsidiaries and intermediates</button>
                        <button class="fake-anchor" @click="excludePLCs">Exclude PLCs</button>
                        <button class="fake-anchor" @click="excludePrivateInvestors">Exclude Private Investors</button>
                        <button class="fake-anchor" @click="excludePrivateEquityHouses">Exclude Private Equity Houses </button>
                        <exclude-companies @arrayChanged="updateExcludedFiles" :uploadedFiles="search.excludeFiles"></exclude-companies>
                    </section>
                </nav>
            </side-menu>

            <main-content>
                <h1 class="visuallyhidden">Search Results</h1>
                <span v-if="search.resultStatus > 0" class="count-error">
                    {{search.resultStatus == 2 ? 'MAX' : search.resultStatus == 1 ? 'ERR' : search.resultCount}}
                    <span v-if="search.resultStatus == 1" title="An error has occured whilst generating your result count"><font-awesome-icon class="too-large" :icon="exclamation" /></span>
                    <span v-if="search.resultStatus == 2" title="Too many search results to calculate, please refine query"><font-awesome-icon class="too-large" :icon="exclamation" /></span>
                    <span v-if="search.resultStatus == 3" title="Large results count, results might be slow to generate"><font-awesome-icon class="warn" :icon="exclamation" title="" /></span>
                </span>
                    <div class="top-bar">
                        <div v-if="selectedLayout != 7 && selectedLayout != 8">
                            <p v-if="searchResults">
                                <strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultsCount}}</strong> companies found
                            </p>

                            <font-awesome-icon icon="spinner" v-if="loading" />
                        </div>
                        <div v-if="selectedLayout == 7">
                            <p v-if="searchResults">
                                <strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultsHistoryCount}}</strong> companies found
                            </p>

                            <font-awesome-icon icon="spinner" v-if="loading" />
                        </div>
                        <div v-if="selectedLayout == 8">
                            <p v-if="searchResults">
                                <strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultsControlSheetCount}}</strong> vendors found
                            </p>

                            <font-awesome-icon icon="spinner" v-if="loading" />
                        </div>
                        <div class="search-controls">
                            <select-input class="select-layout" :identifier="'selectTableLayout'" :options="tableLayouts" v-model="selectedLayout" v-on:valueChanged="layoutChange()"></select-input>

                            <export-results :companySearchId="companySearchId" :selectedLayout="selectedLayout" :selectedResults="checkedBoxes" :selectedDealResults="checkedDealBoxes"></export-results>
                        </div>
                    </div>
                    <div class="pagination" v-if="searchResults">
                        <button class="fake-anchor" @click="previousResults"><font-awesome-icon icon="arrow-left" /> Previous</button>
                        |
                        <button class="fake-anchor" @click="nextResults">Next <font-awesome-icon icon="arrow-right" /></button>
                    </div>

                <div class="search-results-table">
                    <!--Research-->
                    <div v-if="selectedLayout == 1" class="table-container">
                        <table class="basic-table research">
                            <thead>
                                <tr>
                                    <th class="sticky sticky-tick"></th>
                                    <th class="sticky sticky-number">Company number</th>
                                    <th class="sticky sticky-number">Applicant ID</th>
                                    <th class="sticky sticky-name width-200">Company name</th>
                                    <th>Matched score</th>
                                    <th v-if="search.excludeBlocked === false" class="width-200">Exclude Reason</th>
                                    <th class="width-300">Web address</th>
                                    <th>Companies House Link</th>
                                    <th>Registered address, region</th>
                                    <th>Turnover &pound;'000s</th>
                                    <th>ShF &pound;'000s</th>
                                    <th>Turnover &pound;'000s -1yr</th>
                                    <th>ShF &pound;'000s -1yr</th>
                                    <th>Trading Address, line 1</th>
                                    <th>Trading Address, line 2</th>
                                    <th>Trading Town</th>
                                    <th>Trading County</th>
                                    <th>Trading Postcode</th>
                                    <th>Business Email</th>
                                    <th>Business Phone</th>
                                    <th>Assets &pound;'000s</th>
                                    <th>Bank &pound;'000s Ltst Yr</th>
                                    <th>Employees</th>
                                    <th class="width-300">Trade description</th>
                                    <th class="width-200">GUO name</th>
                                    <th>SIC</th>
                                    <th class="width-300">Keywords</th>
                                    <th class="width-300">Business Overview</th>
                                    <th>Main Buyer Contact 1 First Name</th>
                                    <th>Main Buyer Contact 1 Last Name</th>
                                    <th>Main Buyer Contact 1 Email</th>
                                    <th>Main Buyer Contact 1 Position</th>
                                    <th>Main Buyer Contact 1 Share Holding %</th>
                                    <th>Main Buyer Contact 2 First Name</th>
                                    <th>Main Buyer Contact 2 Last Name</th>
                                    <th>Main Buyer Contact 2 Email</th>
                                    <th>Main Buyer Contact 2 Position</th>
                                    <th>Main Buyer Contact 2 Share Holding %</th>
                                    <th>Main Buyer Contact 3 First Name</th>
                                    <th>Main Buyer Contact 3 Last Name</th>
                                    <th>Main Buyer Contact 3 Email</th>
                                    <th>Main Buyer Contact 3 Position</th>
                                    <th>Main Buyer Contact 3 Share Holding %</th>
                                    <th class="width-300">Additional Information</th>
                                    <th class="width-300">Additional BQ Information</th>
                                    <th>BQ Status</th>
                                    <th class="width-300">Interest Summary</th>
                                    <th>Preferred Location</th>
                                    <th>Equity Investment</th>
                                    <th>Has PE Backing</th>
                                    <th>PE Firms</th>
                                    <th>Only Interested In</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index)   in searchResults" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td class="sticky sticky-tick"><checkbox-input class="field" :label=" (resultsPage * resultsPerPage) + index + 1" :identifier="'check' + index" v-model="item.checked" v-on:valueChanged="checkedChanged(item)"></checkbox-input></td>
                                    <td class="sticky sticky-number">
                                        {{item.registeredNumber}}
                                    </td>
                                    <td class="sticky sticky-number">
                                        {{item.internalReference}}
                                    </td>
                                    <td class="sticky sticky-name fake-anchor" v-on:click="detailsPage(item.companyId)"><span>{{item.companyName}}</span><span v-if="item.previousCompanyName"> (previously known as {{item.previousCompanyName}})</span></td>
                                    <td>{{item.weight}}</td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    <td>
                                        <a :href="websiteUrl(item.websiteUrl)" target="_blank" v-if="item.websiteUrl && item.websiteUrl != '0'">{{item.websiteUrl.substring(0, 80)}}</a>
                                        <!--<span v-if="toggleWebsiteUrl[index]"><a :href="websiteUrl(item.websiteUrl)" target="_blank" v-if="item.websiteUrl && item.websiteUrl != '0'">{{item.websiteUrl}}</a> <a @click="toggleWebsiteUrlShowMore(index)" class="show-more"> show less</a></span>
        <span v-if="!toggleWebsiteUrl[index] && item.websiteUrl"><a :href="websiteUrl(item.websiteUrl)" target="_blank" v-if="item.websiteUrl && item.websiteUrl != '0'">{{item.websiteUrl.substring(0, 80)}}</a><span v-if="item.websiteUrl.length > 80">... <a @click="toggleWebsiteUrlShowMore(index)" class="show-more"> show more</a></span></span>-->
                                    </td>
                                    <td><a :href="'https://beta.companieshouse.gov.uk/company/' + item.registeredNumber" target="_blank">View</a></td>
                                    <td>{{item.region}}</td>
                                    <td><span v-if="item.turnover">{{addCommasToNumber(item.turnover)}}</span></td>
                                    <td><span v-if="item.shareholderFunds">{{addCommasToNumber(item.shareholderFunds)}}</span></td>
                                    <td><span v-if="item.turnoverPrev1">{{addCommasToNumber(item.turnoverPrev1)}}</span></td>
                                    <td><span v-if="item.shareholderFundsPrev1">{{addCommasToNumber(item.shareholderFundsPrev1)}}</span></td>

                                    <!--<td>{{item.buyerLastName}}</td>
    <td>{{item.buyerFirstName}}</td>
    <td>{{item.buyerTitle}}</td>-->
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressLine1}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressLine2}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressTown}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressCounty}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.postcode}}</td>
                                    <td :class="{ donotuse: item.businessEmailDoNotUse}">{{item.businessEmail}}</td>
                                    <!--<td :class="{ donotuse: item.businessPhoneDoNotUse}">{{item.businessPhone}}</td>-->
                                    <td :class="{ donotuse: item.buyerPhoneDoNotUse}">{{item.buyerPhone}}</td>
                                    <td><span v-if="item.assets">{{addCommasToNumber(item.assets)}}</span></td>
                                    <td><span v-if="item.bank">{{addCommasToNumber(item.bank)}}</span></td>
                                    <td>{{item.employees}}</td>
                                    <td>
                                        <span v-if="toggleTradeDesc[index]">{{item.tradeDescription}} <a @click="toggleTradeShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleTradeDesc[index] && item.tradeDescription">{{item.tradeDescription.substring(0, 80)}}<span v-if="item.tradeDescription.length > 80">... <a @click="toggleTradeShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>{{item.guoCompanyName}}</td>
                                    <td>{{item.sicCode}}</td>

                                    <td>
                                        <span v-if="toggleKeyWords[index]">{{item.keywords}} <a @click="toggleKeyWordShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleKeyWords[index] && item.keywords">{{item.keywords.substring(0, 80)}}<span v-if="item.keywords.length > 80">... <a @click="toggleKeyWordShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>

                                    <td>
                                        <span v-if="toggleBusinessOverview[index]">{{item.businessOverview}} <a @click="toggleBusinessOverviewShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleBusinessOverview[index] && item.businessOverview">{{item.businessOverview.substring(0, 80)}}<span v-if="item.businessOverview.length > 80">... <a @click="toggleBusinessOverviewShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>

                                    <td>{{item.buyerFirstName}}</td>
                                    <td>{{item.buyerLastName}}</td>
                                    <td :class="{ donotuse: item.buyerEmailDoNotUse}">{{item.buyerEmail}}</td>
                                    <td>{{item.buyerPosition}}</td>
                                    <td>{{item.buyerShareholding}}</td>
                                    <td>{{item.buyerFirstName2}}</td>
                                    <td>{{item.buyerLastName2}}</td>
                                    <td :class="{ donotuse: item.buyerEmailDoNotUse2}">{{item.buyerEmail2}}</td>
                                    <td>{{item.buyerPosition2}}</td>
                                    <td>{{item.buyerShareholding2}}</td>
                                    <td>{{item.buyerFirstName3}}</td>
                                    <td>{{item.buyerLastName3}}</td>
                                    <td :class="{ donotuse: item.buyerEmailDoNotUse3}">{{item.buyerEmail3}}</td>
                                    <td>{{item.buyerPosition3}}</td>
                                    <td>{{item.buyerShareholding3}}</td>
                                    <td class="width-300">
                                        <span v-if="toggleAdditionalInformation[index]">{{item.buyerAdditionalInformationString}}<a @click="toggleAdditionalInformationShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleAdditionalInformation[index] && item.buyerAdditionalInformationString">{{item.buyerAdditionalInformationString.substring(0, 80)}}<span v-if="item.buyerAdditionalInformationString.length > 80">... <a @click="toggleAdditionalInformationShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>


                                    <td class="width-300">
                                        <span v-if="toggleAdditionalBQInformation[index]">{{item.additionalBQInformationString}} <a @click="toggleAdditionalBQInformationShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleAdditionalBQInformation[index] && item.additionalBQInformationString">{{item.additionalBQInformationString.substring(0, 80)}}<span v-if="item.additionalBQInformationString.length > 80">... <a @click="toggleAdditionalBQInformationShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>{{item.bqStatusString}}</td>
                                    <td>
                                        <span v-if="toggleInterestSummary[index]">{{item.interestSummary}} <a @click="toggleInterestSummaryShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleInterestSummary[index] && item.interestSummary">{{item.interestSummary.substring(0, 80)}}<span v-if="item.interestSummary.length > 80">... <a @click="toggleInterestSummaryShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>{{item.preferredLocation}}</td>
                                    <td>{{item.investingAndDebt}}</td>
                                    <td>{{item.hasPEBackingString}}</td>
                                    <td>{{item.peFirms}}</td>
                                    <td>
                                        <span v-if="toggleOnlyInterestedIn[index]">{{item.onlyInterestedIn}} <a @click="toggleOnlyInterestedInShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleOnlyInterestedIn[index] && item.onlyInterestedIn">{{item.onlyInterestedIn.substring(0, 80)}}<span v-if="item.onlyInterestedIn.length > 80">... <a @click="toggleOnlyInterestedInShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--Mailer-->
                    <div v-if="selectedLayout == 2" class="table-container">
                        <table class="basic-table mailer">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="width-150">Company number</th>
                                    <th class="width-100">Internal Ref</th>
                                    <th class="width-200">Company name</th>
                                    <th v-if="search.excludeBlocked === false">Exclude Reason</th>
                                    <!--<th>Matched score</th>-->
                                    <!--<th>Web address</th>-->
                                    <!--<th>Companies House Link</th>-->
                                    <th>Main Buyer Contact Surname</th>
                                    <th>Main Buyer Contact First Name</th>
                                    <th>Main Buyer Contact Salutation</th>
                                    <th>Trading Address, line 1</th>
                                    <th>Trading Address, line 2</th>
                                    <th>Trading Town</th>
                                    <th>Trading County</th>
                                    <th>Trading Postcode</th>
                                    <th>BQ Status</th>
                                    <th>Reference</th>
                                    <th>Researcher Name</th>
                                    <th>Researcher DDI</th>
                                    <th>Researcher Email</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index) in searchResults" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td><checkbox-input class="field" :label="(resultsPage * resultsPerPage) + index + 1" :identifier="'check' + index" v-model="item.checked"></checkbox-input></td>
                                    <td>{{item.registeredNumber}}</td>
                                    <td>{{item.internalReference}}</td>
                                    <td class="sticky sticky-name fake-anchor" v-on:click="detailsPage(item.companyId)"><span>{{item.companyName}}</span><span v-if="item.previousCompanyName"> (previously known as {{item.previousCompanyName}})</span></td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    }}
                                    <!--<td>{{item.weight}}</td>
                                    <td><a :href="websiteUrl(item.websiteUrl)" target="_blank" v-if="item.websiteUrl && item.websiteUrl != '0'">{{item.websiteUrl}}</a></td>
                                                    <td><a :href="'https://beta.companieshouse.gov.uk/company/' + item.registeredNumber" target="_blank">View</a></td>-->
                                    <td>{{item.buyerLastName}}</td>
                                    <td>{{item.buyerFirstName}}</td>
                                    <td>{{item.buyerTitle}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressLine1}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressLine2}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressTown}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressCounty}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.postcode}}</td>
                                    <td>{{item.bQStatusString}}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--Finance-->
                    <div v-if="selectedLayout == 3" class="table-container">
                        <table class="basic-table finance">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="width-200">Company number</th>
                                    <th class="width-100">Internal Ref</th>
                                    <th class="width-200">Company name</th>
                                    <th v-if="search.excludeBlocked === false">Exclude Reason</th>
                                    <th>Matched score</th>
                                    <th>Web address</th>
                                    <th>Companies House Link</th>
                                    <th>Registered address, region</th>

                                    <th>Turnover &pound;'000s</th>
                                    <th>EBITDA 	&pound;'000s</th>
                                    <th>ShF &pound;'000s</th>
                                    <th>Assets &pound;'000s</th>
                                    <th>Bank &pound;'000s Ltst Yr</th>
                                    <th>Employees</th>

                                    <th>Turnover &pound;'000s -1yr</th>
                                    <th>EBITDA &pound;'000s -1yr</th>
                                    <th>ShF &pound;'000s -1yr</th>
                                    <th>Assets &pound;'000s -1yr</th>
                                    <th>Bank &pound;'000s Ltst Yr -1yr</th>
                                    <th>Employees -1yr</th>

                                    <th class="width-300">Trade Description</th>
                                    <th>GUO name</th>
                                    <th>Accountant Name</th>
                                    <th>BQ Status</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index) in searchResults" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td><checkbox-input class="field" :label="(resultsPage * resultsPerPage) + index + 1" :identifier="'check' + index" v-model="item.checked"></checkbox-input></td>

                                    <td>{{item.registeredNumber}}</td>
                                    <td>{{item.internalReference}}</td>
                                    <td class="sticky sticky-name fake-anchor" v-on:click="detailsPage(item.companyId)"><span>{{item.companyName}}</span><span v-if="item.previousCompanyName"> (previously known as {{item.previousCompanyName}})</span></td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    <td>{{item.weight}}</td>
                                    <td><a :href="websiteUrl(item.websiteUrl)" target="_blank" v-if="item.websiteUrl && item.websiteUrl != '0'">{{item.websiteUrl}}</a></td>
                                    <td><a :href="'https://beta.companieshouse.gov.uk/company/' + item.registeredNumber" target="_blank">View</a></td>
                                    <td>{{item.region}}</td>

                                    <td><span v-if="item.turnover">{{addCommasToNumber(item.turnover)}}</span></td>
                                    <td><span v-if="item.ebitda">{{addCommasToNumber(item.ebitda)}}</span></td>
                                    <td><span v-if="item.shareholderFunds">{{addCommasToNumber(item.shareholderFunds)}}</span></td>
                                    <td><span v-if="item.assets">{{addCommasToNumber(item.assets)}}</span></td>
                                    <td><span v-if="item.bank">{{addCommasToNumber(item.bank)}}</span></td>
                                    <td><span v-if="item.employees">{{addCommasToNumber(item.employees)}}</span></td>

                                    <td><span v-if="item.turnoverPrev1">{{addCommasToNumber(item.turnoverPrev1)}}</span></td>
                                    <td><span v-if="item.ebitdaPrev1">{{addCommasToNumber(item.ebitdaPrev1)}}</span></td>
                                    <td><span v-if="item.shareholderFundsPrev1">{{addCommasToNumber(item.shareholderFundsPrev1)}}</span></td>
                                    <td><span v-if="item.assetsPrev1">{{addCommasToNumber(item.assetsPrev1)}}</span></td>
                                    <td><span v-if="item.bankPrev1">{{addCommasToNumber(item.bankPrev1)}}</span></td>
                                    <td><span v-if="item.employeesPrev1">{{addCommasToNumber(item.employeesPrev1)}}</span></td>

                                    <td>
                                        <span v-if="toggleTradeDesc[index]">{{item.tradeDescription}} <a @click="toggleTradeShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleTradeDesc[index] && item.tradeDescription">{{item.tradeDescription.substring(0, 80)}}<span v-if="item.tradeDescription.length > 80">... <a @click="toggleTradeShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>{{item.guoCompanyName}}</td>
                                    <td>{{item.accountantName}}</td>
                                    <td>{{item.bQStatusString}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--MArketing-->
                    <div v-if="selectedLayout == 4" class="table-container">
                        <table class="basic-table marketing">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Company number</th>
                                    <th>Internal Ref</th>
                                    <th class="width-200">Company name</th>
                                    <th v-if="search.excludeBlocked === false">Exclude Reason</th>
                                    <th>Matched score</th>
                                    <th>Web address</th>
                                    <th>Companies House Link</th>
                                    <th>Registered address, region</th>

                                    <th>Turnover &pound;'000s</th>
                                    <th>ShF &pound;'000s</th>
                                    <th>Turnover &pound;'000s -1yr</th>
                                    <th>ShF &pound;'000s -1yr</th>
                                    <th>Main Buyer Contact Surname</th>
                                    <th>Main Buyer Contact First Name</th>
                                    <th>Main Buyer Contact Salutation</th>
                                    <th>Trading Address, line 1</th>
                                    <th>Trading Address, line 2</th>
                                    <th>Trading Town</th>
                                    <th>Trading County</th>
                                    <th>Trading Postcode</th>
                                    <th>Business Email</th>
                                    <th>Main Buyer ContactE-mail address</th>
                                    <th>Business Phone</th>
                                    <th>Main Buyer Contact Telephone number</th>
                                    <th>Assets &pound;'000s</th>
                                    <th>Bank &pound;'000s Ltst Yr</th>
                                    <th>Employees</th>
                                    <th class="width-300">Trade description</th>
                                    <th>GUO name</th>
                                    <th>SIC</th>
                                    <th>BQ Status</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index) in searchResults" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td><checkbox-input class="field" :label="(resultsPage * resultsPerPage) + index + 1" :identifier="'check' + index" v-model="item.checked"></checkbox-input></td>

                                    <td>{{item.registeredNumber}}</td>
                                    <td>{{item.internalReference}}</td>
                                    <td class="sticky sticky-name fake-anchor" v-on:click="detailsPage(item.companyId)"><span>{{item.companyName}}</span><span v-if="item.previousCompanyName"> (previously known as {{item.previousCompanyName}})</span></td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    <td>{{item.weight}}</td>
                                    <td><a href="" target="_blank" /></td>
                                    <td><a :href="'https://beta.companieshouse.gov.uk/company/' + item.registeredNumber" target="_blank">View</a></td>
                                    <td>{{item.region}}</td>
                                    <td><span v-if="item.turnover">{{addCommasToNumber(item.turnover)}}</span></td>
                                    <td><span v-if="item.shareholderFunds">{{addCommasToNumber(item.shareholderFunds)}}</span></td>
                                    <td><span v-if="item.turnoverPrev1">{{addCommasToNumber(item.turnoverPrev1)}}</span></td>
                                    <td><span v-if="item.shareholderFundsPrev1">{{addCommasToNumber(item.shareholderFundsPrev1)}}</span></td>
                                    <td>{{item.buyerLastName}}</td>
                                    <td>{{item.buyerFirstName}}</td>
                                    <td>{{item.buyerTitle}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressLine1}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressLine2}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressTown}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.addressCounty}}</td>
                                    <td :class="{ donotuse: item.businessDoNotMail}">{{item.postcode}}</td>
                                    <td :class="{ donotuse: item.businessEmailDoNotUse}">{{item.businessEmail}}</td>
                                    <td :class="{ donotuse: item.buyerEmailDoNotUse}">{{item.buyerEmail}}</td>
                                    <td :class="{ donotuse: item.businessPhoneDoNotUse}">{{item.businessPhone}}</td>
                                    <td :class="{ donotuse: item.buyerPhoneDoNotUse}">{{item.buyerPhone}}</td>
                                    <td><span v-if="item.assets">{{addCommasToNumber(item.assets)}}</span></td>
                                    <td><span v-if="item.bank">{{addCommasToNumber(item.bank)}}</span></td>
                                    <td>{{item.employees}}</td>
                                    <td>
                                        <span v-if="toggleTradeDesc[index]">{{item.tradeDescription}} <a @click="toggleTradeShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleTradeDesc[index] && item.tradeDescription">{{item.tradeDescription.substring(0, 80)}}<span v-if="item.tradeDescription.length > 80">... <a @click="toggleTradeShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>{{item.guoCompanyName}}</td>
                                    <td>{{item.sicCode}}</td>
                                    <td>{{item.bQStatusString}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--Client-->
                    <div v-if="selectedLayout == 5" class="table-container">
                        <table class="basic-table client">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Company number</th>
                                    <th>Internal Ref</th>
                                    <th class="width-300">Company name</th>
                                    <th v-if="search.excludeBlocked === false">Exclude Reason</th>
                                    <th>Matched score</th>
                                    <th>Registered address, region</th>

                                    <th>Web address</th>
                                    <th class="width-300">Trade description</th>
                                    <th class="width-300">Keywords</th>
                                    <th>SIC</th>
                                    <th>Previous Acquisitions (yes/no)</th>
                                    <th>BQ Status</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index) in searchResults" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td><checkbox-input class="field" :label="(resultsPage * resultsPerPage) + index + 1" :identifier="'check' + index" v-model="item.checked"></checkbox-input></td>

                                    <td>{{item.registeredNumber}}</td>
                                    <td>{{item.internalReference}}</td>
                                    <td class="sticky sticky-name fake-anchor" v-on:click="detailsPage(item.companyId)"><span>{{item.companyName}}</span><span v-if="item.previousCompanyName"> (previously known as {{item.previousCompanyName}})</span></td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    <td>{{item.weight}}</td>
                                    <td>{{item.region}}</td>
                                    <td><a :href="websiteUrl(item.websiteUrl)" target="_blank" v-if="item.websiteUrl && item.websiteUrl != '0'">{{item.websiteUrl}}</a></td>
                                    <td>
                                        <span v-if="toggleTradeDesc[index]">{{item.tradeDescription}} <a @click="toggleTradeShowMore(index)"> show less</a></span>
                                        <span v-if="!toggleTradeDesc[index] && item.tradeDescription">{{item.tradeDescription.substring(0, 80)}}<span v-if="item.tradeDescription.length > 80">... <a @click="toggleTradeShowMore(index)"> show more</a></span></span>
                                    </td>
                                    <td>
                                        <span v-if="toggleKeyWords[index]">{{item.keywords}} <a @click="toggleKeyWordShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleKeyWords[index] && item.keywords">{{item.keywords.substring(0, 80)}}<span v-if="item.keywords.length > 80">... <a @click="toggleKeyWordShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>{{item.sicCode}}</td>
                                    <td>{{item.hasPreviousAcquisition}}</td>
                                    <td>{{item.bQStatusString}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!--Cross Match-->
                    <div v-if="selectedLayout == 6" class="table-container">
                        <table class="basic-table cross-match">
                            <thead>
                                <tr>
                                    <th class="width-100"></th>
                                    <th class="width-100">Company Number</th>

                                    <th class="width-100">Applicant ID</th>
                                    <th class="width-300">Company Name</th>
                                    <th class="width-300" v-if="search.excludeBlocked === false">Exclude Reason</th>
                                    <th class="width-80">Matched Score</th>
                                    <th class="width-200">Reference</th>
                                    <!--<th>Buyer Type</th>-->
                                    <th class="width-150">Registered Address Region</th>
                                    <th class="width-100">Turnover &pound;'000s</th>
                                    <th class="width-100">ShF &pound;'000</th>

                                    <th class="width-100">Turnover &pound;'000s -1yr</th>
                                    <th class="width-100">ShF &pound;'000 -1yr</th>
                                    <th class="width-100">Assets &pound;'000</th>

                                    <th class="width-100">Bank &pound;'000s Ltst Y</th>

                                    <th class="width-300">GUO name</th>

                                    <th class="width-80">Main Buyer Contact Title</th>
                                    <th class="width-150">Main Buyer Contact First Name</th>
                                    <th class="width-150">Main Buyer Contact Last Name</th>
                                    <th class="width-200">Main Buyer Contact Full Name</th>
                                    <th class="width-200">Main Buyer Contact Position</th>
                                    <th class="width-300">Main Buyer Contact E-mail address</th>

                                    <th class="width-300">Additional Information</th>
                                    <th class="width-200">Additional B.Q. Information</th>
                                    <th class="width-200">BQ Status</th>
                                    <th class="width-200">Financials</th>
                                    <th class="width-200">Transaction Funded</th>
                                    <th class="width-200">Previous Acquisitions</th>
                                    <th class="width-200">AMLCompleted</th>
                                    <th class="width-200">Interest Summary</th>
                                    <th class="width-200">Preferred Location</th>
                                    <th class="width-200">Equity Investment</th>
                                    <th class="width-200">Has PE Backing</th>

                                    <th class="width-200">PE Firms</th>
                                    <th class="width-200">Appetite Notes</th>
                                    <th class="width-200">Only Interested In</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index) in searchResults" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td><checkbox-input class="field" :label="(resultsPage * resultsPerPage) + index + 1" :identifier="'check' + index" v-model="item.checked"></checkbox-input></td>
                                    <td class="width-100">{{item.registeredNumber}}</td>
                                    <td class="width-100">{{item.internalReference}}</td>
                                    <td class="sticky sticky-name fake-anchor" v-on:click="detailsPage(item.companyId)"><span>{{item.companyName}}</span><span v-if="item.previousCompanyName"> (previously known as {{item.previousCompanyName}})</span></td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    <td class="width-80">{{item.weight}}</td>
                                    <td class="width-100">
                                        <span v-if="toggleClientInternalRef[index]">{{item.clientInternalRef}} <a @click="toggleClientInternalRefShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleClientInternalRef[index] && item.clientInternalRef">{{item.clientInternalRef.substring(0, 80)}}<span v-if="item.clientInternalRef.length > 80">... <a @click="toggleClientInternalRefShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td class="width-150">{{item.region}}</td>
                                    <td class="width-100"><span v-if="item.turnover">{{addCommasToNumber(item.turnover)}}</span></td>
                                    <td class="width-100"><span v-if="item.shareholderFunds">{{addCommasToNumber(item.shareholderFunds)}}</span></td>

                                    <td class="width-100"><span v-if="item.turnoverPrev1">{{addCommasToNumber(item.turnoverPrev1)}}</span></td>
                                    <td class="width-100"><span v-if="item.shareholderFundsPrev1">{{addCommasToNumber(item.shareholderFundsPrev1)}}</span></td>
                                    <td class="width-100"><span v-if="item.assets">{{addCommasToNumber(item.assets)}}</span></td>

                                    <td class="width-100"><span v-if="item.bank">{{addCommasToNumber(item.bank)}}</span></td>

                                    <td class="width-300">{{item.guoCompanyName}}</td>

                                    <td class="width-80">{{item.buyerTitle}}</td>
                                    <td class="width-150">{{item.buyerLastName}}</td>
                                    <td class="width-150">{{item.buyerFirstName}}</td>
                                    <td class="width-200">{{item.buyerFullName}}</td>
                                    <td class="width-200">{{item.buyerPosition}}</td>

                                    <td class="width-300" :class="{ donotuse: item.buyerEmailDoNotUse}">{{item.buyerEmail}}</td>

                                    <td class="width-300">{{item.buyerAdditionalInformation}}</td>
                                    <td class="width-200">{{item.additionalBQInformation}}</td>
                                    <td class="width-200">{{item.bQStatusString}}</td>

                                    <td>{{item.financials}}</td>
                                    <td>{{item.transactionFunded}}</td>
                                    <td>{{item.previousAcquisitions}}</td>
                                    <td>{{item.amlCompletedString}}</td>
                                    <td>
                                        <span v-if="toggleInterestSummary[index]">{{item.interestSummary}} <a @click="toggleInterestSummaryShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleInterestSummary[index] && item.interestSummary">{{item.interestSummary.substring(0, 80)}}<span v-if="item.interestSummary.length > 80">... <a @click="toggleInterestSummaryShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>{{item.preferredLocation}}</td>
                                    <td>{{item.investingAndDebt}}</td>
                                    <td>{{item.hasPEBackingString}}</td>
                                    <td>{{item.peFirms}}</td>
                                    <td>
                                        <span v-if="toggleAppetiteNotes[index]">{{item.appetiteNotes}} <a @click="toggleAppetiteNotesShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleAppetiteNotes[index] && item.appetiteNotes">{{item.appetiteNotes.substring(0, 80)}}<span v-if="item.appetiteNotes.length > 80">... <a @click="toggleAppetiteNotesShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td>
                                        <span v-if="toggleOnlyInterestedIn[index]">{{item.onlyInterestedIn}} <a @click="toggleOnlyInterestedInShowMore(index)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleOnlyInterestedIn[index] && item.onlyInterestedIn">{{item.onlyInterestedIn.substring(0, 80)}}<span v-if="item.onlyInterestedIn.length > 80">... <a @click="toggleOnlyInterestedInShowMore(index)" class="show-more"> show more</a></span></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!--BME Deals-->
                    <div v-if="selectedLayout == 7" class="table-container">
                        <table class="basic-table deals">
                            <thead>
                                <tr>
                                    <th class="width-50"></th>
                                    <th class="width-100">Deal Number</th>
                                    <th class="width-200">Acquiror Company Name</th>
                                    <th class="width-100">Acquiror Registered Number</th>
                                    <th class="width-200" v-if="search.excludeBlocked === false">Exclude Reason</th>
                                    <th class="width-200">Target Company Name</th>
                                    <th class="width-100">Target Registered Number</th>
                                    <th class="width-100">Deal Status</th>
                                    <th class="width-150">Deal Type</th>
                                    <th class="width-100">Completed Date</th>

                                    <th class="width-100">Total Stake (%)</th>
                                    <th class="width-300">AcquisitionKeywords</th>
                                    <th class="width-300">Acquiror Sectors</th>

                                    <th class="width-300">Acquiror Subsectors</th>

                                    <th class="width-300">Target Sectors</th>

                                    <th class="width-300">Target Subsectors</th>

                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index2) in searchResultsAcquisitionHistory" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td><checkbox-input class="field" :label="(resultsPage * resultsPerPage) + index2 + 1" :identifier="'checkDeal' + index2" v-model="item.checked" v-on:valueChanged="checkedDealsChanged(item)"></checkbox-input></td>
                                    <td class="width-100">{{item.dealNumber}}</td>
                                    <td class="width-200">{{item.acquirorName}}</td>
                                    <td class="width-80">{{item.acquirorRegisteredNumber}}</td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    <td class="width-200"><a :href="'#/company-details/' + companySearchId + '/' + item.targetCompanyID" target="_blank">{{item.targetName}}</a></td>
                                    <td class="width-100">{{item.targetRegisteredNumber}}</td>
                                    <td class="width-100">{{item.dealStatus}}</td>
                                    <td class="width-150">{{item.dealType}}</td>
                                    <td class="width-100">{{formatDate(item.completedDate)}}</td>
                                    <td class="width-150">{{item.totalStakePercentage}}</td>
                                    <td>
                                        <span v-if="toggleAcquisitionKeywords[index2]">{{item.acquisitionKeywords}} <a @click="toggleAcquisitionKeywordShowMore(index2)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleAcquisitionKeywords[index2] && item.acquisitionKeywords">{{item.acquisitionKeywords.substring(0, 80)}}<span v-if="item.acquisitionKeywords.length > 80">... <a @click="toggleAcquisitionKeywordShowMore(index2)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td class="width-300">{{item.acquirorSectors}}</td>
                                    <td>
                                        <span v-if="toggleAcquirorSubSection[index2]">{{item.acquirorSubsectors}} <a @click="toggleAcquirorSubSectionShowMore(index2)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleAcquirorSubSection[index2] && item.acquirorSubsectors">{{item.acquirorSubsectors.substring(0, 80)}}<span v-if="item.acquirorSubsectors.length > 80">... <a @click="toggleAcquirorSubSectionShowMore(index2)" class="show-more"> show more</a></span></span>
                                    </td>
                                    <td class="width-300">{{item.targetSectors}}</td>
                                    <td>
                                        <span v-if="toggleTargetSubSection[index2]">{{item.targetSubsectors}} <a @click="toggleTargetSubSectionShowMore(index2)" class="show-more"> show less</a></span>
                                        <span v-if="!toggleTargetSubSection[index2] && item.targetSubsectors">{{item.targetSubsectors.substring(0, 80)}}<span v-if="item.targetSubsectors.length > 80">... <a @click="toggleTargetSubSectionShowMore(index2)" class="show-more"> show more</a></span></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--BME Control Sheet-->
                    <div v-if="selectedLayout == 8" class="table-container">
                        <table class="basic-table controlsheet">
                            <thead>
                                <tr>
                                    <th class="width-50"></th>
                                    <th class="width-200">Company Name</th>
                                    <th class="width-100">Company Number</th>
                                    <th class="width-200" v-if="search.excludeBlocked === false">Exclude Reason</th>
                                    <th class="width-100">First Name</th>
                                    <th class="width-100">Last Name</th>
                                    <th class="width-200">Email</th>
                                    <th class="width-200">Business Email</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(item, index2) in searchResultsControlSheet" :key="item.companySearchId" :class="{blocked:item.excludeFromES}">
                                    <td><checkbox-input class="field" :label="(controlSheetResultsPage * resultsPerPage) + index2 + 1" :identifier="'checkControlSheet' + index2" v-model="item.checked" v-on:valueChanged="checkedControlSheetChanged(item)"></checkbox-input></td>
                                    <td class="sticky sticky-name fake-anchor" v-on:click="detailsPage(item.companyId)"><span>{{item.companyName}}</span></td>
                                    <td>{{item.registeredNumber}}</td>
                                    <td v-if="search.excludeBlocked === false">{{item.excludeReason}}</td>
                                    <td>{{item.firstName}}</td>
                                    <td>{{item.lastName}}</td>
                                    <td :class="{ donotuse: item.DoNotUseEmailAddress}">{{item.emailAddress}}</td>
                                    <td :class="{ donotuse: item.DoNotUseBusinessEmailAddress}">{{item.businessEmailAddress}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="pagination" v-if="searchResults">
                    <p v-if="selectedLayout != 7 && selectedLayout != 8">
                        <strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultsCount}}</strong> companies found
                    </p>
                    <p v-if="selectedLayout == 7">
                        <strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultsHistoryCount}}</strong> companies found
                    </p>
                    <p v-if="selectedLayout == 8">
                        <strong>{{lowerPage}}</strong> to <strong>{{upperPage}}</strong> of <strong>{{resultsControlSheetCount}}</strong> companies found
                    </p>
                    <button class="fake-anchor" @click="previousResults"><font-awesome-icon icon="arrow-left" /> Previous</button>
                    |
                    <button class="fake-anchor" @click="nextResults">Next <font-awesome-icon icon="arrow-right" /></button>
                </div>
            </main-content>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import Vue from 'vue'
    import SiteHeader from '../components/header/SiteHeader'
    import InputButton from '../components/reusable/InputButton'
    import SideMenu from '../components/reusable/SideMenu'
    import Breadcrumb from '../components/reusable/Breadcrumb'
    import MainContent from '../components/reusable/MainContent'
    import TextInput from '../components/reusable/TextInput'
    import SelectInput from '../components/reusable/SelectInput'
    import CheckboxInput from '../components/reusable/CheckboxInput'
    import PrintIcon from '../components/other/PrintIcon'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import UploadCompanies from '../components/other/UploadCompanies'
    import ExcludeCompanies from '../components/other/ExcludeCompanies'
    import CriteriaSelected from '../components/other/CriteriaSelected'
    import ExportResults from '../components/other/ExportResults'
    import { faExclamationTriangle } from '@fortawesome/fontawesome-free-solid'
    import moment from 'moment'
    import { mapState, mapActions } from 'vuex'
    import { isSet, isArray, isJsonString } from '../helpers/helpers';
    import { companysearchmodule } from "../store/modules/companysearchmodule";

    export default {
        name: 'SearchResults',
        data() {
            return {
                savePagePromise: null,
                checkedBoxes: [],
                checkedDealBoxes: [],
                checkedControlSheetBoxes: [],
                toggleTradeDesc: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleKeyWords: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleAcquirorSubSection: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleTargetSubSection: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),

                toggleAcquisitionKeywords: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleBusinessOverview: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                togglePersonalEquityNotes: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleAdditionalInformation: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleAdditionalBQInformation: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleInterestSummary: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleAppetiteNotes: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleOnlyInterestedIn: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                toggleClientInternalRef: Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false),
                exclamation: faExclamationTriangle
            }
        },
        props: ['companySearchId'],
        components: {
            SiteHeader,
            InputButton,
            SideMenu,
            Breadcrumb,
            MainContent,
            TextInput,
            SelectInput,
            CheckboxInput,
            PrintIcon,
            FontAwesomeIcon,
            UploadCompanies,
            ExcludeCompanies,
            CriteriaSelected,
            ExportResults
        },
        created() {

            this.search.companySearchId = this.companySearchId;
            this.$store.dispatch('companysearchmodule/getCompanySearch');
            this.$store.commit('companysearchresultmodule/updateCompanySearchResultsId', this.companySearchId)

            this.loadResults();
            this.getTableLayouts();
        },
        computed: {
            ...mapState({
                companySearchResultsId: state => state.companysearchresultmodule.companySearchResultsId,
                loading: state => state.companysearchresultmodule.loading,
                searchResults: state => state.companysearchresultmodule.searchResults,
                searchResultsAcquisitionHistory: state => state.companysearchresultmodule.searchResultsAcquisitionHistory,
                searchResultsControlSheet: state => state.companysearchresultmodule.searchResultsControlSheet,
                resultsCount: state => state.companysearchresultmodule.resultsCount,
                resultsHistoryCount: state => state.companysearchresultmodule.resultsHistoryCount,
                resultsControlSheetCount: state => state.companysearchresultmodule.resultsControlSheetCount,

                dataLoaded: state => state.companysearchmodule.dataLoaded,
                tableLayouts: state => state.tablelayoutmodule.tableLayouts,
                resultsPage: state => state.companysearchresultmodule.resultsPage,
                generalResultsPage: state => state.companysearchresultmodule.generalResultsPage,
                dealResultsPage: state => state.companysearchresultmodule.dealResultsPage,
                controlSheetResultsPage: state => state.companysearchresultmodule.controlSheetResultsPage,
                previousLayout: state => state.companysearchresultmodule.previousLayout,
                resultsPerPage: state => state.companysearchresultmodule.resultsPerPage
            }),
            search: {
                get() {
                    return this.$store.state.companysearchmodule.search
                },
                set(value) {
                    this.$store.commit('companysearchmodule/updateSearch', value)
                }
            },
            selectedLayout: {
                get() {
                    return this.$store.state.tablelayoutmodule.selectedLayout
                },
                set(value) {
                    this.$store.commit('tablelayoutmodule/selectedLayout', value)
                }
            },
            lowerPage() {
                if (this.selectedLayout == 7) {
                    return 1;
                }
                if (this.selectedLayout == 8) {
                    if (this.upperPage > 0) return (this.controlSheetResultsPage * this.resultsPerPage) + 1;
                }
                else {
                    if (this.upperPage > 0) return (this.resultsPage * this.resultsPerPage) + 1;

                }
                return 0;
            },
            upperPage() {
                if (this.selectedLayout == 7) {
                    return this.resultsHistoryCount;
                }
                else if (this.selectedLayout == 8) {
                    let thisPage = ((this.controlSheetResultsPage + 1) * this.resultsPerPage);
                    if (thisPage < this.resultsControlSheetCount) return thisPage;
                    else return this.resultsControlSheetCount;
                }
                else {
                    let thisPage = ((this.resultsPage + 1) * this.resultsPerPage);
                    if (thisPage < this.resultsCount) return thisPage;
                    else return this.resultsCount;
                }
                return 0;
            }
        },
        methods: {
            ...mapActions('companysearchmodule', [
                'requestCompanySaveNoCount'
            ]),
            ...mapActions('tablelayoutmodule', [
                'getTableLayouts'
            ]),

            detailsPage(companyId) {
                this.$router.push({ path: '/company-details/' + this.companySearchId + '/' + companyId })
            },
            loadResults() {

                //console.log('loadResults');

                if (isSet(this.companySearchResultsId)) {
                    //console.log('loadResults - companySearchResultsId is set');
                    // this.$store.commit('companysearchresultmodule/updateResultsPage', 0)

                    this.$store.dispatch('companysearchresultmodule/getCompanySearchResults').then(() => {
                        this.toggleTradeDesc = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                        this.toggleKeyWords = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);

                        this.$store.dispatch('companysearchresultmodule/getCompanySearchAcquisitionHistoryResults').then(() => {

                            this.toggleAcquisitionKeywords = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                            this.toggleAcquirorSubSection = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                            this.toggleTargetSubSection = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                            this.$store.dispatch('companysearchresultmodule/getCompanyControlSheetSearchResults').then(() => {
                                //console.log('Loaded Control Sheet')
                            });
                        });
                    });
                }
                else {
                    console.log('loadResults - companySearchResultsId is NOT set');
                }
            },
            formChanged(event) {

                console.log('formChanged');
                this.$store.dispatch('companysearchresultmodule/setLoading');
                this.requestCompanySaveNoCount(false).then(result => {
                    this.$store.dispatch('companysearchresultmodule/unsetLoading');
                    console.log('requestCompanySaveNoCount');
                    this.loadResults();
                });
            },
            excludeSubsidiariesAndIntermediates() {
                this.search.excludeSubsidiariesAndIntermediates = true;
                this.formChanged();
            },
            excludePLCs() {
                this.search.excludePLCs = true;
                this.formChanged();
                this.loading = true;
            },
            excludePrivateInvestors() {
                this.search.excludePrivateInvestors = true;
                this.formChanged();
            },
            excludePrivateEquityHouses() {
                this.search.excludePrivateEquityHouses = true;
                this.formChanged();
            },
            updateUploadedFiles(val) {
                this.search.files = val;
                this.formChanged();
            },
            updateExcludedFiles(val) {
                this.search.excludedFiles = val;
                this.formChanged();
            },
            removeSelected() {
                let removeList = this.searchResults.filter(x => x.checked === true).map(x => x.registeredNumber);
                let removeList2 = this.searchResultsAcquisitionHistory.filter(x => x.checked === true).map(x => x.targetRegisteredNumber);
                let removeList3 = this.searchResultsControlSheet.filter(x => x.checked === true).map(x => x.registeredNumber);
                let removeListAll = removeList.concat(removeList2, removeList3);
                let updateNeeded = false;

                for (let companyNumber of removeListAll) {
                    if (this.search.includeCompanyNumbers.map(x => x.companyNumber).includes(companyNumber)) {
                        this.search.includeCompanyNumbers = this.search.includeCompanyNumbers.filter(function (x) {
                            return !(x.companyNumber === companyNumber);
                        });
                        updateNeeded = true;
                    }
                    else {
                        if (isSet(companyNumber) && this.search.excludeCompanyNumbers.filter(x => x.companyNumber === companyNumber).length === 0) {
                            this.search.excludeCompanyNumbers.push({ companyNumber: companyNumber });
                            updateNeeded = true;
                        }
                    }

                }

                if (updateNeeded) this.formChanged();
            },

            excludeBlockedChange() {
                this.search.excludeBlocked = !this.search.excludeBlocked;
                this.formChanged();
            },
            nextResults() {
                if (this.selectedLayout == 7) {
                    if ((this.resultsPage * this.resultsPerPage) + this.resultsPerPage < this.resultsHistoryCount) {

                        this.$store.commit('companysearchresultmodule/updateResultsPage', this.resultsPage + 1);
                        this.loadDealsResultsOnly();
                    }
                }
                else if (this.selectedLayout == 8) {
                    if ((this.controlSheetResultsPage * this.resultsPerPage) + this.resultsPerPage < this.resultsControlSheetCount) {

                        this.$store.commit('companysearchresultmodule/updateControlSheetResultsPage', this.controlSheetResultsPage + 1);
                        this.loadControlSheetResultsOnly();
                    }
                }
                else {
                    if ((this.resultsPage * this.resultsPerPage) + this.resultsPerPage < this.resultsCount) {

                        this.$store.commit('companysearchresultmodule/updateResultsPage', this.resultsPage + 1);
                        this.loadSearchResultsOnly();
                    }
                }
            },
            previousResults() {
                if (this.selectedLayout == 7) {
                    this.loadDealsResultsOnly();
                }
                else if (this.selectedLayout == 8) {
                    if (this.controlSheetResultsPage >= 1) {
                        this.$store.commit('companysearchresultmodule/updateControlSheetResultsPage', this.controlSheetResultsPage - 1);
                        this.loadControlSheetResultsOnly();
                    }
                }
                else {
                    if (this.resultsPage >= 1) {

                        this.$store.commit('companysearchresultmodule/updateResultsPage', this.resultsPage - 1)
                        this.loadSearchResultsOnly();
                    }

                }

            },
            loadSearchResultsOnly() {
                this.$store.dispatch('companysearchresultmodule/getCompanySearchResults').then(() => {

                    var filtered = this.searchResults.filter(x => this.checkedBoxes.includes(x.companyId));
                    for (var i = 0; i < filtered.length; i++) {
                        filtered[i].checked = true;
                    }
                    this.toggleTradeDesc = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                    this.toggleKeyWords = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                });
            },
            loadDealsResultsOnly() {
                this.$store.dispatch('companysearchresultmodule/getCompanySearchAcquisitionHistoryResults').then(() => {
                    this.toggleAcquisitionKeywords = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                    this.toggleAcquirorSubSection = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                    this.toggleTargetSubSection = Array.apply(null, Array(100)).map(Boolean.prototype.valueOf, false);
                    var filteredDeals = this.searchResultsAcquisitionHistory.filter(x => this.checkedDealBoxes.includes(x.companyAcquisitionHistoryId));
                    for (var i = 0; i < filteredDeals.length; i++) {
                        filteredDeals[i].checked = true;
                    }
                });
            },
            loadControlSheetResultsOnly() {
                this.$store.dispatch('companysearchresultmodule/getCompanyControlSheetSearchResults').then(() => {
                    var filtered = this.searchResultsControlSheet.filter(x => this.checkedControlSheetBoxes.includes(x.companyVendorId));

                    for (var i = 0; i < filtered.length; i++) {
                        filtered[i].checked = true;
                    }
                });
            },
            layoutChange() {

                if (this.selectedLayout != 7 && this.previousLayout == 7) {
                    this.$store.commit('companysearchresultmodule/updatedealResultsPage', this.resultsPage)
                    this.$store.commit('companysearchresultmodule/updateResultsPage', this.generalResultsPage)

                    this.loadSearchResultsOnly();
                }
                if (this.selectedLayout == 7) {
                    this.$store.commit('companysearchresultmodule/updategeneralResultsPage', this.resultsPage)
                    this.$store.commit('companysearchresultmodule/updateResultsPage', this.dealResultsPage)

                    this.loadDealsResultsOnly();
                }
                if (this.selectedLayout == 8) {
                    this.loadControlSheetResultsOnly();
                }
                this.$store.commit('companysearchresultmodule/updatepreviousLayout', this.selectedLayout)

            },
            toggleTradeShowMore(id) {
                Vue.set(this.toggleTradeDesc, id, !this.toggleTradeDesc[id]);
            },
            toggleKeyWordShowMore(id) {
                Vue.set(this.toggleKeyWords, id, !this.toggleKeyWords[id]);
            },
            toggleAcquisitionKeywordShowMore(id2) {
                Vue.set(this.toggleAcquisitionKeywords, id2, !this.toggleAcquisitionKeywords[id2]);
            },
            toggleAcquirorSubSectionShowMore(id2) {
                Vue.set(this.toggleAcquirorSubSection, id2, !this.toggleAcquirorSubSection[id2]);
            },
            toggleTargetSubSectionShowMore(id2) {
                Vue.set(this.toggleTargetSubSection, id2, !this.toggleTargetSubSection[id2]);
            },
            toggleBusinessOverviewShowMore(id) {
                Vue.set(this.toggleBusinessOverview, id, !this.toggleBusinessOverview[id]);
            },
            togglePersonalEquityNoteShowMore(id) {
                Vue.set(this.togglePersonalEquityNotes, id, !this.togglePersonalEquityNotes[id]);
            },
            toggleAdditionalInformationShowMore(id) {
                Vue.set(this.toggleAdditionalInformation, id, !this.toggleAdditionalInformation[id]);
            },
            toggleAdditionalBQInformationShowMore(id) {
                Vue.set(this.toggleAdditionalBQInformation, id, !this.toggleAdditionalBQInformation[id]);
            },
            toggleInterestSummaryShowMore(id) {
                Vue.set(this.toggleInterestSummary, id, !this.toggleInterestSummary[id]);
            },
            toggleAppetiteNotesShowMore(id) {
                Vue.set(this.toggleAppetiteNotes, id, !this.toggleAppetiteNotes[id]);
            },
            toggleOnlyInterestedInShowMore(id) {
                Vue.set(this.toggleOnlyInterestedIn, id, !this.toggleOnlyInterestedIn[id]);
            },
            toggleClientInternalRefShowMore(id) {
                Vue.set(this.toggleClientInternalRef, id, !this.toggleClientInternalRef[id]);
            },
            websiteUrl(url) {
                if (isSet(url)) {
                    if (url.indexOf('http') > -1) return url;
                    else return 'http://' + url;
                }
            },
            addCommasToNumber(number) {
                return number.toLocaleString('en', { useGrouping: true });
            },
            formatDate(date) {

                let formattedDate = moment(date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY');
                if (formattedDate === 'Invalid date') return '';
                else return formattedDate;
            },
            FixNullText(stringToCheck) {
                if (string.length = 0)
                    return '';
                else return stringToCheck;
            },
            checkedChanged(item) {

                if (item.checked === true) {
                    this.checkedBoxes.push(item.companyId);
                } else {
                    this.checkedBoxes = this.checkedBoxes.filter(x => x !== item.companyId);
                }
            },
            checkedDealsChanged(item) {

                if (item.checked === true) {
                    this.checkedDealBoxes.push(item.companyAcquisitionHistoryId);
                } else {
                    this.checkedDealBoxes = this.checkedDealBoxes.filter(x => x !== item.companyAcquisitionHistoryId);
                }
            },
            checkedControlSheetChanged(item) {

                if (item.checked === true) {
                    this.checkedControlSheetBoxes.push(item.companyVendorId);
                } else {
                    this.checkedControlSheetBoxes = this.checkedControlSheetBoxes.filter(x => x !== item.companyVendorId);
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

    .search-results {
        padding-bottom: 40px;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .container {
        display: block;
        height: 100%;
        padding: 30px 30px 0 30px;

        @media only screen and (min-width: 800px) {
            display: flex;
            overflow: hidden;
        }
    }

    .donotuse {
        color: red;
    }

    .btn,
    h3 {
        svg {
            width: 18px;
            height: 18px;
        }
    }

    .pagination {
        .fake-anchor {
            cursor: pointer;
        }
    }

    .side-menu {
        margin: 0;
        width: 100%;

        .btn {
            width: 100%;
        }

        ul {
            margin-bottom: 40px;
        }

        ul li {
            margin-bottom: 20px;
        }

        .fake-anchor {
            text-align: left;
            margin-bottom: 10px;
        }

        @media only screen and (min-width: 800px) {
            width: 30%;
        }

        @media only screen and (min-width: 1500px) {
            width: 25%;
        }
    }

    .main-content {
        margin: 30px 30px 0 0;
        width: 100%;
        display: block;
        flex-direction: column;

        h3 {
            margin-top: 0;
        }

        @media only screen and (min-width: 800px) {
            margin: 0 0 0 30px;
            overflow: hidden;
            display: flex;
            width: 70%;
        }

        @media only screen and (min-width: 800px) {
        }

        @media only screen and (min-width: 1500px) {
            width: 75%;
        }
    }

    .criteria-selected {
        h3 {
            svg {
                width: 18px;
                height: 18px;
                margin-left: 5px;
            }
        }

        li svg {
            color: #c7c7c7;
            width: 16px;
            height: 16px;
            cursor: pointer;
            margin-right: 5px;
        }

        ul {
            margin-bottom: 20px;
        }

        ul li {
            font-size: 0.9em;
            margin-bottom: 5px;
        }

        .fake-anchor {
            display: block;
            cursor: pointer;
        }
    }

    .top-bar {
        display: flex;
        min-height: 60px;

        > div:nth-child(1) {
            display: flex;
            margin-right: 30px;

            p {
                margin: 10px 0 20px 0;
            }

            @media only screen and (min-width: 800px) {
                min-width: 280px;
            }
        }

        h3,
        .search-controls {
            flex-grow: 1;
        }

        .search-controls {
            text-align: right;
            display: flex;

            .select-layout {
                flex-grow: 10;
                text-align: right;
            }

            .excel-export {
                margin-top: 5px;
                flex-grow: 0.3;
            }
        }
    }

    .table-container {

        @media only screen and (max-width: 800px) {
            overflow: auto;
        }

        table {
            margin-top: 20px;
            width: 100%;
            font-size: 14px;

            th:first-child {
                min-width: 80px;
            }

            th,
            td {
                padding: 5px;
                font-weight: normal;
                word-wrap: break-word;
            }

            tr {
                max-height: 74px;
            }

            thead th {
                background: #a8e6ff;
            }

            td {
                background: white;
            }

            tr:nth-child(even) td {
                background: #fbfbfb;
            }

            tr.blocked td {
                background-color: #FF7276 !important;
            }

            .width-50 {
                width: 50px;
            }

            .width-80 {
                width: 80px;
            }

            .width-100 {
                width: 100px;
            }

            .width-150 {
                width: 150px;
            }

            .width-200 {
                width: 200px;
            }

            .width-250 {
                width: 250px;
            }

            .width-300 {
                width: 300px;
            }
        }
    }

    table.research {
        width: 6300px;
        table-layout: fixed;
        /*		td:nth-child(22), th:nth-child(22), td:nth-child(25), th:nth-child(25), td:nth-child(26), th:nth-child(26) {
                width:500px;
        }*/
        /*		td:nth-child(3), th:nth-child(3), td:nth-child(5), th:nth-child(5), td:nth-child(23), th:nth-child(23) {
            width: 300px;
        }*/
        /*		td:nth-child(4), th:nth-child(4) {
            width: 100px;
        }
        td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/

        .sticky {
            position: sticky;
            position: -webkit-sticky;
            cursor: pointer;
        }

        .sticky-tick {
            left: 0px;
        }

        .sticky-name {
            left: 210px;
            cursor: pointer;
        }

        .sticky-number {
            left: 100px;
            width: 110px;
            max-width: 110px;
            min-width: 110px;
        }
    }

    table.mailer {
        width: 3000px;
        table-layout: fixed;
        /*        td:nth-child(3), th:nth-child(3) {
            width: 300px;
        }

        td:nth-child(4), th:nth-child(4) {
            width: 100px;
        }

        td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/
    }

    table.finance {
        width: 4000px;
        table-layout: fixed;
        /*td:nth-child(20), th:nth-child(20) {
            width: 500px;
        }

        td:nth-child(3), th:nth-child(3), td:nth-child(21), th:nth-child(21) {
            width: 300px;
        }

        td:nth-child(4), th:nth-child(4) {
            width: 100px;
        }

        td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/
    }

    table.marketing {
        width: 5500px;
        table-layout: fixed;
        /*td:nth-child(27), th:nth-child(27), td:nth-child(30), th:nth-child(30) {
            width: 500px;
        }

        td:nth-child(3), th:nth-child(3), td:nth-child(28), th:nth-child(28) {
            width: 300px;
        }

        td:nth-child(4), th:nth-child(4) {
            width: 90px;
        }

        td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/
    }

    table.client {
        width: 2300px;
        table-layout: fixed;
        /*td:nth-child(7), th:nth-child(7), td:nth-child(8), th:nth-child(8) {
            width: 500px;
        }

        td:nth-child(3), th:nth-child(3), td:nth-child(28), th:nth-child(28) {
            width: 300px;
        }

        td:nth-child(4), th:nth-child(4) {
            width: 100px;
        }

        td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/
    }

    table.cross-match {
        width: 3600px;
        table-layout: fixed;
        /* td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/
    }

    table.deals {
        width: 2000px;
        table-layout: fixed;
        /*td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/
    }

    table.controlsheet {
        width: 2000px;
        table-layout: fixed;
        /*td:nth-child(1), th:nth-child(1) {
            width: 100px;
        }*/
    }

    .fa-spinner {
        margin-left: 10px;
    }

    .search-results-table {
        width: 100%;
        height: 100%;

        @media only screen and (min-width: 800px) {
            overflow: scroll;
        }
    }

    .count-error {
        margin: 0;
        padding: 7px 10px;
        border: 1px solid #e4e4e4;
        min-width: 200px;
        max-width:200px;
        display: flex;

        span {
            font-weight: bold;
            margin-right: 5px;
        }

        @media only screen and (max-width: 800px) {
            min-width: initial;
        }
    }

    .too-large {
        color: orangered;
        cursor: help;
    }

    .warn {
        color: orange;
    }

    .show-more {
        cursor: pointer;
    }
</style>
